import script from "./jijia-verify-code-wrap.vue?vue&type=script&lang=ts&setup=true"
export * from "./jijia-verify-code-wrap.vue?vue&type=script&lang=ts&setup=true"

import "./jijia-verify-code-wrap.vue?vue&type=style&index=0&id=064a7fae&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-064a7fae"]])

export default __exports__